import { createSelector } from '@reduxjs/toolkit';

import {
  CheckResultWithLoadCaseGuid,
  getCheckResultsForActiveAnalysisSet,
} from './getCheckResultsForActiveAnalysisSetSelector';
import { getSelectedAnalysisResult } from './getSelectedAnalysisResultSelector';

export const getCheckResultsForActiveLoadCase = createSelector(
  getSelectedAnalysisResult,
  getCheckResultsForActiveAnalysisSet,
  (selectedAnalysisResult, checkResultsForActiveAnalysisSet): readonly CheckResultWithLoadCaseGuid[] | null => {
    if (!selectedAnalysisResult) return checkResultsForActiveAnalysisSet;
    return selectedAnalysisResult.checkResults.map((checkResult) => ({
      ...checkResult,
      loadCaseGuid: selectedAnalysisResult.loadCaseGuid,
    }));
  },
);
